import { memo } from 'react';

import { usePlayerStore } from '@air/component-player';

import { useAnnotationV2Store } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';
import { getCommentRangePercentStyle } from '~/components/v2/components/asset-modal/visualizer/video/getCommentRangePercentStyle';

export const VideoCommentRangeBarDim = memo(() => {
  const duration = usePlayerStore((state) => state.duration);
  const commentRange = useAnnotationV2Store((state) => state.commentRange);

  if (!commentRange || duration <= 0 || commentRange.startTime === commentRange.endTime) {
    return null;
  }

  const startTime = Math.min(commentRange.startTime, commentRange.endTime);
  const endTime = Math.max(commentRange.startTime, commentRange.endTime);

  return (
    <>
      {startTime > 0 ? (
        <div
          className="pointer-events-none absolute bottom-0 h-1 rounded-4 bg-black/50 dark:bg-black/50"
          data-testid="VIDEO_COMMENT_RANGE_BAR_DIM_START"
          style={getCommentRangePercentStyle({ startTime: 0, endTime: startTime }, duration)}
        />
      ) : null}
      {endTime < duration ? (
        <div
          className="pointer-events-none absolute bottom-0 h-1 rounded-4 bg-black/50 dark:bg-black/50"
          data-testid="VIDEO_COMMENT_RANGE_BAR_DIM_END"
          style={getCommentRangePercentStyle({ startTime: endTime, endTime: duration }, duration)}
        />
      ) : null}
    </>
  );
});

VideoCommentRangeBarDim.displayName = 'VideoCommentRangeBarDim';
